module.exports = __webpack_public_path__ + "static/tools-resources-coffee-chat-photo-d74abbc588f4aaadab31ae71d9ad3bb7.jpg";